import { render, staticRenderFns } from "./card.vue?vue&type=template&id=5f1e3617&scoped=true"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"
import style0 from "./card.vue?vue&type=style&index=0&id=5f1e3617&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1e3617",
  null
  
)

export default component.exports